import React from 'react';
import { useTranslation } from '../../i18n';
import type { ChatParticipant } from './chatTypes';
import { ChatAvatar } from './ChatBubble';

type ChatHeaderProps = {
  peer: ChatParticipant;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
};

export function ChatHeader({ peer, subtitle, actions }: ChatHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between gap-3 border-b border-[#eef0f4] px-5 py-3">
      <div className="flex min-w-0 items-center gap-3">
        <ChatAvatar participant={peer} size={36} rounded="lg" />
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <span className="truncate text-[15px] font-semibold text-slate-800">{peer.name}</span>
            {peer.online ? (
              <span className="size-2 shrink-0 rounded-full bg-emerald-500" aria-label={t('chat.online')} />
            ) : null}
          </div>
          {subtitle ? <div className="truncate text-xs text-slate-400">{subtitle}</div> : null}
        </div>
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  );
}
